import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { ProfileService } from 'src/app/services/profile.service';
import { CONSTANTS } from 'src/app/shared/constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DeleteAcountComponent } from 'src/app/components/modals/delete-acount/delete-acount.component';
import { LoadingAkanaService } from 'src/app/services/loading-akana.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AuthenticationService } from 'src/app/services/authentication.service';

declare var document;

@Component({
  standalone: false,
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1500, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class SettingsComponent implements OnInit {

  settings: UntypedFormGroup;
  passForm: UntypedFormGroup;
  type = 'password';
  squals: boolean;
  saveInfor: any;
  showProgress = true;
  showPassProgress = true;
  newType = 'password';
  showChangePass = sessionStorage.getItem('change_pass_SCF') === 'Y_P' ? false : true;
  showLoading = false;
  key: string;

  constructor(private f: UntypedFormBuilder,
      private recaptcha: ReCaptchaV3Service, 
      private profile: ProfileService, 
      private r: Router, 
      private cs: CommonsService, 
      private snackBar: MatSnackBar, 
      private modal: MatDialog, 
      private l: LoadingAkanaService,
      private serviceAuthen: AuthenticationService) { }

  ngOnInit() {
    this.getKey();
    this.cs.firstChargePage('Profile', 'Vista de administración del perfil personal', 'funnel');
    this.cs.eventsAnalitics('visit screen', 'content', 'Profile');
    this.showLoadingMethod(true);
    this.createForms();
    this.profile.getDataForm().subscribe(d => {
      if (d.Code === 200) {
        this.getValuesForm(d.UserData ? d.UserData : null);
      }
      if (d.Code === 401) {
        this.cs.openModalSession();
      }
    }, err => {
      if (err) {
        this.cs.openModalSession();
      }
    });
  }

  getKey() {
    if (!sessionStorage.getItem('k_ca')) {
      this.serviceAuthen.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  createForms = (d?: any) => {
    this.settings = this.f.group({
      name: new UntypedFormControl('', [Validators.maxLength(255)]),
      surname: new UntypedFormControl('', [Validators.maxLength(255)]),
      email: new UntypedFormControl({ value: '', disabled: true }, [Validators.pattern(CONSTANTS.REG_EXP_MAIL)]),
      surnameTwo: new UntypedFormControl('', [Validators.maxLength(255)]),
      phone: new UntypedFormControl('', [Validators.maxLength(9), Validators.minLength(9), this.patternValidator(/^(6|7|9)[0-9]*$/, { notValid: true })]),
      ofers: new UntypedFormControl(false, []),
    }, {});
    this.passForm = this.f.group({
      currentPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(8),
      this.patternValidator(/\d/, { hasNumber: true }),
      this.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      this.patternValidator(/[a-z]/, { hasSmallCase: true })]),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(8),
      this.patternValidator(/\d/, { hasNumber: true }),
      this.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      this.patternValidator(/[a-z]/, { hasSmallCase: true })]),
      passwordTwo: new UntypedFormControl('', [Validators.required])
    }, {});
    this.passForm.valueChanges.subscribe(form => {
      this.saveInfor = form;
      if (this.checkPassword(form) && form.passwordTwo === form.password && form.currentPassword !== form.password) {
        this.passForm.controls.passwordTwo.setErrors(null);
        this.squals = false;
      } else if (this.checkPassword(form) && this.passForm.controls.currentPassword.touched) {
        this.passForm.controls.passwordTwo.setErrors({ wrongPass: true });
        this.squals = true;
      }
    });
  }

  checkPassword = (f: any) => {
    return this.passForm.controls.currentPassword.dirty && this.passForm.controls.password.dirty && this.passForm.controls.passwordTwo.dirty &&
      f.password && f.passwordTwo && f.currentPassword;
  }

  getValuesForm = (d: any) => {
    this.settings.controls['name'].setValue(d ? d.Name : '');
    this.settings.controls['surname'].setValue(d ? d.SurName1 : '');
    this.settings.controls['surnameTwo'].setValue(d ? d.SurName2 : '');
    this.settings.controls['email'].setValue(d ? d.Email : '');
    this.settings.controls['phone'].setValue(d ? d.Phone : '');
    this.settings.controls['ofers'].setValue(d ? d.PolPri : false);
    setTimeout(() => {
      this.showLoadingMethod(false);
    }, CONSTANTS.timeLoading);
  }

  /**
   * Muestra la password al mantenerla pulsada
   * @param num: number
   */
  showPass = (num: number) => {
    if (num === 1) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  showNewPass = (num: number) => {
    if (num === 1) {
      this.newType = 'text';
    } else {
      this.newType = 'password';
    }
  }

  deleteAccount = () => {
    this.openModal();
  }

  /**
   * Guarda la contraseña actualizada 
   */
  savePass = () => {
    if (this.passForm.invalid) {
      return;
    } else {
      this.showPassProgress = false;
      const body = {
        PValue: this.passForm.get('password').value ? btoa(this.passForm.get('password').value) : '',
        POldValue: this.passForm.get('currentPassword').value ? btoa(this.passForm.get('currentPassword').value) : '',
      };
      this.recaptcha.execute(this.key, 'submit', (token) => {
        this.profile.savePValue(body, token).subscribe((d: any) => {
          if (d.Code === 200) {
            this.snackBar.open('Contraseña actualizada correctamente', '', {
              duration: 2000,
            });
            this.passForm.reset();
          }
          if (d.Code === 401) {
            this.cs.openModalSession();
          }
          this.showPassProgress = true;
        }, err => {
          this.showPassProgress = true;
          this.cs.openModalSession();
        });
      }, { useGlobalDomain: false });
    }
  }

  /**
   * Guarda los cambios de la informacion del perfil
   */
  saveInformation = () => {
    if (this.settings.invalid) {
      return;
    } else {
      this.showProgress = false;
      const body = {
        Name: this.settings.get('name').value ? this.settings.get('name').value : '',
        SurName1: this.settings.get('surname').value ? this.settings.get('surname').value : '',
        SurName2: this.settings.get('surnameTwo').value ? this.settings.get('surnameTwo').value : '',
        Phone: this.settings.get('phone').value ? this.settings.get('phone').value : '',
        Email: this.settings.get('email').value ? this.settings.get('email').value : '',
        PolPri: this.settings.get('ofers').value ? true : false
      };

      this.profile.saveProfile(body).subscribe((d: any) => {
        if (d.Code === 200) {
          this.snackBar.open('Información actualizada correctamente', '', {
            duration: 2000,
          });
        }
        if (d.Code === 401) {
          this.cs.openModalSession();
        }
        this.showProgress = true;
      }, error => {
        this.cs.openModalSession();
        this.showProgress = true;
      });
    }
  }

  private patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  private openModal = (): void => {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-del-account';
    modalConfig.maxWidth = '670px';
    modalConfig.minWidth = '320px';
    modalConfig.disableClose = true;
    this.cs.eventsAnalitics('click', 'Modal para eliminar cuenta', 'Modal de informacion');
    const mod = this.modal.open(DeleteAcountComponent, modalConfig);
    mod.afterClosed().subscribe((d: any) => {
      if (d) {
        this.showLoadingMethod(true);
        this.profile.deleteProfile().subscribe((d: any) => {
          setTimeout(() => {
            this.showLoadingMethod(false);
          }, CONSTANTS.timeLoading);
          if (d.Code === 200) {
            this.cs.finishSession(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.r.navigateByUrl('home');
          }
          if (d.Code === 401) {
            this.cs.openModalSession();
          } else {
            this.showLoadingMethod(false);
          }
        }, () => this.showLoadingMethod(false));
      } else {
        return;
      }
    });
  }

  /**
   * muestra o esconde el modal
   */
  private showLoadingMethod = (value: boolean) => {
    this.showLoading = value;
    if (!value) {
      document.querySelector('body').style.overflow = '';
    }
  }
}
